<section class="page-hero">
    <div class="hero-copy">
        <p class="eyebrow">Marketing resources</p>
        <h1>You will not need to create everything yourself.</h1>
        <p class="lede">Approved ambassadors receive ready-to-use materials that make YachtApp easy to present online,
            in person, and at the marina.</p>
    </div>
</section>
<section class="content-section resource-list">
    <div>QR codes</div>
    <div>Flyers</div>
    <div>Posters</div>
    <div>Stickers</div>
    <div>Social media graphics</div>
    <div>Videos</div>
    <div>Product screenshots</div>
    <div>Demo account</div>
    <div>Presentation PDF</div>
</section>
<section class="content-section">
    <h2>Get the materials for your next campaign.</h2>
    <p>Sign in to find onboarding guides, approved social copy, and logo downloads in the ambassador resources portal.
        To request current screenshots, printed materials, a presentation, or a demo, contact YachtApp with your
        ambassador account email, campaign format, and intended audience.</p>
    <p>New to the program? Apply first. Campaign-specific materials and usage terms are confirmed during approval.</p>
    <nav class="cta-row" aria-label="Access marketing resources">
        <a class="button-link" routerLink="/resources">Open ambassador resources</a>
        <a class="button-link secondary" href="https://yachtapp.net/contact">Request campaign materials</a>
        <a class="button-link secondary" routerLink="/signup">Apply to join</a>
    </nav>
</section>
